import styled from 'styled-components';

export const ExpandableWrapper = styled.div`
  padding: 0px 13px;
  background: #f5f7fb;
  border-radius: 8px;
  margin-bottom: 8px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const ExpandableItem = styled.div`
  flex: 1;
`;

export const Line = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: ${(props: {
    $itemsGridCol?: any;
    $expandedItems?: string[];
  }) => props.$itemsGridCol};
  grid-gap: 16px;
  padding: 12px 0px;
  padding-left: ${(props: { $expandedItems?: string[] }) =>
    props.$expandedItems?.length ? '40.93px' : '4px'};
  background: #f5f7fb;
  border-radius: 8px;
  position: relative;
`;

export const ExpandableProductControl = styled.button`
  background-color: transparent;
  outline: none;
  border: none;
  position: absolute;
  top: 12px;
  cursor: pointer;
`;

export const ExpandedLine = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: ${(props: { $expandedItemsGridCol?: any }) =>
    props.$expandedItemsGridCol};
  grid-gap: 16px;
  padding: 12px 24px;
  background: #f5f7fb;
  border-radius: 8px;
  height: fit-content;
  transition: all 2s;
`;

export const Divider = styled.hr`
  border: 1px solid #e6e8f0;
`;
